<template>
  <div class="monitor water-breaking-news" style="font-size: 16px; width: 100%; background: #eff1f5">
    <div class="content">
      <div class="yuliang" ref="yuliang">
        <div class="select clearfix" ref="operation">
          <span class="desc">时间选择:</span>
          <el-date-picker
            v-model="queryTime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            :clearable="false"
            placeholder="选择发布时间"
            @change="loadReport"
          />
          <span id="export" @click="exportDocx">
            <span class="export-icon" ref="downloadArea"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv" v-loading="loading">
          <div class="tinymce" style="width: 100%; height: 100%">
            <editor id="water-breaking-news-editor" v-model="tinymceHtml" :init="init" />
          </div>
        </div>
      </div>
      <div class="chart-renderers" aria-hidden="true">
        <div ref="shizhuChart"></div>
        <div ref="nanxiChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import htmlDocx from 'html-docx-js/dist/html-docx'
import saveAs from 'file-saver'
import tinymce from 'tinymce/tinymce.min.js'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/print'
import 'tinymce/icons/default/icons'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
import comprehensiveMapTypes from '@/store/types/comprehensiveMap'

const formatDate = value => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日${String(date.getHours()).padStart(2, '0')}时`
}

const escapeHtml = value => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')

const formatReportText = value => String(value)
  .split(/(-?\d+(?:\.\d+)?)/g)
  .map((part, index) => index % 2 ? `<span style="color: #00f;">${escapeHtml(part)}</span>` : escapeHtml(part))
  .join('')
  .replace(/\r?\n/g, '<br>')

const formatTableValue = (value, fallback = '/') => value === null || value === undefined || value === '' ? fallback : value

const formatNumber = (value, digits) => {
  const number = Number(value)
  return value !== null && value !== undefined && value !== '' && Number.isFinite(number) ? number.toFixed(digits) : '/'
}

const getAvailableStorage = item => item.warningWaterStorage === null || item.warningWaterStorage === undefined ||
  item.waterStorage === null || item.waterStorage === undefined
  ? '/'
  : formatNumber(Number(item.warningWaterStorage) - Number(item.waterStorage), 2)

export default {
  name: 'WaterBreakingNews',
  components: { Editor },
  data () {
    return {
      loading: false,
      queryTime: '',
      issue: '202601',
      tinymceHtml: '',
      chartImages: {
        shizhu: '',
        nanxi: ''
      },
      chartInstances: {},
      init: {
        selector: '.tinymce',
        language_url: 'tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'tinymce/skins/ui/oxide',
        content_css: 'tinymce/water_rain_briefing.css',
        auto_focus: false,
        height: '100%',
        plugins: 'print link lists image code table colorpicker textcolor wordcount contextmenu',
        toolbar: 'print bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        menubar: false,
        inline: false
      }
    }
  },
  methods: {
    buildRainfallHtml (data) {
      const rainList = Array.isArray(data.rainList) ? data.rainList : []
      const tableStyle = 'width: 100%; border-collapse: collapse; margin: 10px 0 20px; font-size: 12pt;'
      const cellStyle = 'border: 1px solid #ccc; padding: 7px; text-align: center; vertical-align: middle;'
      const rows = rainList.map(item => `<tr>
        <td style="${cellStyle}">${escapeHtml(formatTableValue(item.addvnm))}</td>
        <td style="${cellStyle}">${escapeHtml(formatTableValue(item.stnm))}</td>
        <td style="${cellStyle}color: #00f;">${escapeHtml(formatTableValue(item.accRain_Str, formatTableValue(item.accRain)))}</td>
      </tr>`).join('')
      const emptyRow = `<tr><td colspan="3" style="${cellStyle}height: 38px;">&nbsp;</td></tr>`
      const bodyStyle = 'font-family: Microsoft YaHei, sans-serif; font-size: 14pt; line-height: 1.8; text-align: justify; text-indent: 2em; margin: 10px 0;'
      return `<p style="font-family: SimHei, Microsoft YaHei, sans-serif; font-size: 18pt; font-weight: bold; margin: 30px 0 16px;">一、雨情</p>
        <p style="${bodyStyle}">${formatReportText(data.rain || '')}</p>
        <table style="${tableStyle}">
          <thead><tr style="background: #b0c0d5;"><th style="${cellStyle}">所在地</th><th style="${cellStyle}">站名</th><th style="${cellStyle}">时段雨量（mm）</th></tr></thead>
          <tbody>${rows || emptyRow}</tbody>
        </table>`
    },
    buildReservoirTables (data) {
      const tableStyle = 'width: 100%; border-collapse: collapse; margin: 10px 0 20px; font-size: 12pt;'
      const cellStyle = 'border: 1px solid #ccc; padding: 7px; text-align: center; vertical-align: middle;'
      const bigRows = (Array.isArray(data.bigResList) ? data.bigResList : []).map(item => {
        const row = [
          formatTableValue(item.addvnm),
          formatTableValue(item.reservoirName, formatTableValue(item.stnm)),
          formatTableValue(item.water_Str, formatTableValue(item.water)),
          formatTableValue(item.warningWater_Str, formatTableValue(item.warningWater)),
          formatTableValue(item.overflowWarningWater_Str, formatTableValue(item.overflowWarningWater)),
          formatNumber(item.waterStorage, 2),
          formatNumber(item.impoundmentRate, 2),
          getAvailableStorage(item),
          formatNumber(item.netRainfall, 1)
        ]
        return `<tr>${row.map((cell, index) => `<td style="${cellStyle}${index > 0 ? 'color: #00f;' : ''}">${escapeHtml(cell)}</td>`).join('')}</tr>`
      }).join('')
      const warnRows = (Array.isArray(data.warnResList) ? data.warnResList : []).map(item => {
        const row = [
          formatTableValue(item.addvnm),
          formatTableValue(item.reservoirName, formatTableValue(item.stnm)),
          formatTableValue(item.water_Str, formatTableValue(item.water)),
          formatTableValue(item.warningWater_Str, formatTableValue(item.warningWater)),
          formatTableValue(item.overflowWarningWater_Str, formatTableValue(item.overflowWarningWater)),
          formatNumber(item.waterStorage, 2),
          formatNumber(item.impoundmentRate, 2)
        ]
        return `<tr>${row.map((cell, index) => `<td style="${cellStyle}${index > 0 ? 'color: #00f;' : ''}">${escapeHtml(cell)}</td>`).join('')}</tr>`
      }).join('')
      const emptyBigRow = `<tr><td colspan="9" style="${cellStyle}height: 38px;">&nbsp;</td></tr>`
      const emptyWarnRow = `<tr><td colspan="7" style="${cellStyle}height: 38px;">&nbsp;</td></tr>`
      return `<p style="font-size: 16pt; margin: 24px 0 8px; text-align: center;">北溪、金溪水库水情</p>
        <table style="${tableStyle}"><thead><tr style="background: #b0c0d5;">${['乡镇名称', '站名', '当前水位（m）', '汛限水位（m）', '超汛限水位（m）', '当前库容（万m³）', '蓄水率（%）', '可拦库容（万m³）', '可纳雨量（mm）'].map(item => `<th style="${cellStyle}">${item}</th>`).join('')}</tr></thead><tbody>${bigRows || emptyBigRow}</tbody></table>
        <p style="font-size: 16pt; margin: 24px 0 8px; text-align: center;">小型水库水情（超汛限）</p>
        <table style="${tableStyle}"><thead><tr style="background: #b0c0d5;">${['乡镇名称', '站名', '当前水位（m）', '汛限水位（m）', '超汛限水位（m）', '当前库容（万m³）', '蓄水率（%）'].map(item => `<th style="${cellStyle}">${item}</th>`).join('')}</tr></thead><tbody>${warnRows || emptyWarnRow}</tbody></table>`
    },
    buildChartFigure (title, image) {
      const content = image
        ? `<p style="margin: 24px 0 8px; text-align: center;"><img src="${image}" alt="${escapeHtml(title)}" width="560" height="224" style="width: 560px; height: 224px; max-width: 100%;"></p>`
        : '<div style="margin: 24px auto 8px; width: 560px; max-width: 100%; height: 224px; border: 1px dashed #9aa6b2; background: #f5f7fa; text-align: center; color: #7b8794; font-size: 14pt; line-height: 224px;">图片加载失败</div>'
      return `${content}<p style="text-align: center; font-size: 14pt; font-weight: normal; margin: 0 0 24px;">${escapeHtml(title)}</p>`
    },
    buildHtml (report) {
      const dateText = formatDate(this.queryTime)
      const data = report && report.result === 'Success' && report.data ? report.data : {}
      const inRes = data.inRes || `截至${dateText}，全县2座中型水库及77座小型水库运行平稳，全县河网水势基本平稳。`
      const outRes = (data.outRes || '县域外流经我县水库水位均在汛限水位以下。').replace(/\s*\r?\n\s*/g, '')
      const river = data.river || `截至${dateText}，重点水位站点水位均在警戒水位以下。`
      const bodyStyle = 'font-family: Microsoft YaHei, sans-serif; font-size: 14pt; line-height: 1.8; text-align: justify; text-indent: 2em; margin: 10px 0;'
      return `<div style="width: 100%; color: #222;">
        <p style="text-align: center; font-family: SimHei, Microsoft YaHei, sans-serif; font-size: 34pt; font-weight: bold; color: #f00; margin: 12px 0 24px;">水 雨 情 快 报</p>
        <table role="presentation" style="width: 100%; border-collapse: collapse; margin: 0; font-size: 14pt;">
          <tr><td style="width: 50%; padding: 0 14pt 7px; text-align: left; border: 0; border-bottom: 2px solid #ff6600;">永嘉县水利局</td><td style="width: 50%; padding: 0 14pt 7px; text-align: right; color: #00f; border: 0; border-bottom: 2px solid #ff6600;">${dateText}</td></tr>
        </table>
        ${this.buildRainfallHtml(data)}
        <p style="font-family: SimHei, Microsoft YaHei, sans-serif; font-size: 18pt; font-weight: bold; margin: 30px 0 16px;">二、水情</p>
        <p style="${bodyStyle}"><strong>县内水库：</strong>${formatReportText(inRes)}</p>
        ${this.buildReservoirTables(data)}
        <p style="${bodyStyle}"><strong>县外水库：</strong>${formatReportText(outRes)}</p>
        <p style="${bodyStyle}"><strong>重点水位站点：</strong>${formatReportText(river)}</p>
        ${this.buildChartFigure('石柱水文站水位雨量图', this.chartImages.shizhu)}
        ${this.buildChartFigure('楠溪江供水工程拦河闸水位雨量图', this.chartImages.nanxi)}
      </div>`
    },
    getChartTimeRange () {
      const end = this.$moment(this.queryTime).startOf('hour')
      const begin = end.clone().subtract(24, 'hours')
      return {
        beginTime: begin.format('YYYY-MM-DD HH:00'),
        endTime: end.format('YYYY-MM-DD HH:00')
      }
    },
    loadStationCharts () {
      const time = this.getChartTimeRange()
      const stations = [
        { key: 'shizhu', ref: 'shizhuChart', sTID: 8750, stationType: 'ZZ,PP' },
        { key: 'nanxi', ref: 'nanxiChart', sTID: 15189, stationType: 'ZZ' }
      ]
      return Promise.all(stations.map(station => this.$store.dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
        sTID: station.sTID,
        stationType: station.stationType,
        beginTime: time.beginTime,
        endTime: time.endTime,
        span: 60
      }).then(data => {
        this.chartImages[station.key] = this.rainChart(data, station.stationType, station.ref)
      }).catch(() => {
        this.chartImages[station.key] = ''
      })))
    },
    rainChart (data, sttp, chartRef) {
      data = data || {}
      const color = '#333'
      const rainData = data.rainValues ? JSON.parse(JSON.stringify(data.rainValues)) : []
      const sortedRain = rainData.sort((a, b) => b - a)
      const rainmax = sortedRain[0] ? Math.round(sortedRain[0] + 2) : 2
      let watermax = data.maxWater ? data.maxWater + 0.2 : 0
      let watermin = data.minWater ? data.minWater - 0.2 : 0
      let max = 0
      let min = 0
      if (data.grZs && data.wrZs) {
        max = Math.max(data.maxWater, data.grZs[0] || data.maxWater, data.wrZs[0] || data.maxWater)
        min = Math.min(data.minWater, data.grZs[0] || data.minWater, data.wrZs[0] || data.minWater)
      } else if (data.grZs) {
        max = Math.max(data.maxWater, data.grZs[0] || data.maxWater)
        min = Math.min(data.minWater, data.grZs[0] || data.minWater)
      } else if (data.wrZs) {
        max = Math.max(data.maxWater, data.wrZs[0] || data.maxWater)
        min = Math.min(data.minWater, data.wrZs[0] || data.minWater)
      }
      const gap = (max - min) / 2
      if (max && min) {
        watermax = max + gap / 2
        watermin = min - gap / 2
      }
      if (!data.maxWater) {
        watermax = null
        watermin = null
      }
      const yAxis = [{
        type: 'value',
        name: '水位(m)',
        min: watermin,
        max: watermax,
        scale: true,
        splitNumber: 5,
        axisLabel: { formatter: value => value.toFixed(1) },
        axisTick: { show: false },
        splitLine: { lineStyle: { opacity: 0.1 } },
        axisLine: { lineStyle: { color } }
      }, {
        type: 'value',
        name: '雨量(mm)',
        nameLocation: 'start',
        interval: 30,
        inverse: true,
        min: 0,
        max: rainmax,
        axisLabel: { formatter: '{value}' },
        axisLine: { lineStyle: { color } }
      }]
      const previousChart = this.chartInstances[chartRef]
      if (previousChart && !previousChart.isDisposed()) previousChart.dispose()
      const chart = this.$echarts.init(this.$refs[chartRef])
      chart.setOption({
        animation: false,
        tooltip: {
          trigger: 'axis',
          formatter: params => params.map((param, index) => `${index === 0 ? param.name + '<br>' : ''}${param.seriesName}：${param.value === undefined ? '-' : param.value}${param.seriesName === '雨量' ? 'mm' : 'm'}`).join('<br>')
        },
        legend: {
          data: ['雨量', { name: '水位', icon: 'line' }, { name: '警戒水位', icon: 'line' }, { name: '保证水位', icon: 'line' }],
          textStyle: { color }
        },
        grid: { left: '1%', right: '2%', bottom: '3%', top: '15%', containLabel: true },
        xAxis: {
          type: 'category',
          data: data.tMs || [],
          axisLine: { show: false, lineStyle: { color } },
          axisTick: { show: false },
          axisLabel: {
            textStyle: { color },
            formatter: value => {
              const parts = value.split(' ')
              return parts.length > 1 ? `${parts[1]}\n${parts[0]}` : value
            }
          }
        },
        yAxis,
        series: [{
          name: '雨量', type: 'bar', yAxisIndex: 1, itemStyle: { color: '#33C9DE' }, data: data.rainValues || []
        }, {
          name: '水位', type: 'line', symbol: 'none', itemStyle: { color: '#48D1CC' }, data: data.waterValues || []
        }, {
          name: sttp.includes('ZZ') ? '警戒水位' : '汛限水位', type: 'line', symbolSize: 0, itemStyle: { color: sttp.includes('ZZ') ? '#FFD700' : 'red' }, data: data.wrZs || []
        }, {
          name: '保证水位', type: 'line', symbolSize: 0, itemStyle: { color: 'red' }, data: data.grZs || []
        }]
      })
      this.chartInstances[chartRef] = chart
      return chart.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' })
    },
    loadReport () {
      this.loading = true
      const reportRequest = this.$store.dispatch(reportAnalysisTypes.WATER_NEWS, { time: this.queryTime }).catch(() => null)
      Promise.all([reportRequest, this.loadStationCharts()])
        .then(([data]) => { this.tinymceHtml = this.buildHtml(data) })
        .then(() => { this.loading = false })
    },
    exportDocx () {
      const content = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>body{font-family:Microsoft YaHei,Arial,sans-serif;color:#222}</style></head><body>${this.tinymceHtml}</body></html>`
      saveAs(htmlDocx.asBlob(content), `永嘉水雨情快报(第${this.issue}期).docx`)
    },
    resizeEditor () {
      if (!this.$refs.yuliang || !this.$refs.operation) return
      this.$refs.yuliang.style.height = `${this.$refs.yuliang.parentElement.offsetHeight - 30}px`
      this.$refs.tableDiv.style.height = `${this.$refs.yuliang.offsetHeight - this.$refs.operation.offsetHeight - 30}px`
    }
  },
  created () {
    const now = new Date()
    this.queryTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:00`
  },
  mounted () {
    tinymce.init({})
    this.loadReport()
    this.$nextTick(this.resizeEditor)
    window.addEventListener('resize', this.resizeEditor)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEditor)
    Object.values(this.chartInstances).forEach(chart => chart.dispose())
  }
}
</script>

<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.yuliang { height: 680px; }
.yuliang /deep/ .tableDiv { margin-top: 15px; width: 98%; margin-left: 1%; overflow: auto; padding-top: 10px; }
.yuliang /deep/ .tox-tinymce { border: 0; }
.chart-renderers {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 900px;
  pointer-events: none;
}
.chart-renderers > div { width: 900px; height: 360px; }
</style>
